import { createContext } from 'react';

import { DataPopperProps, DataPopperRowProps } from './types';

export const DataPopperContext = createContext<{
  popperProps: DataPopperProps;
  rowProps?: DataPopperRowProps;
}>({ popperProps: undefined } as never);
